export default {
      id: "social-small-tikTok-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "sprite.svg#social-small-tikTok",
      toString: function () {
        return this.url;
      }
    }